module.exports = __webpack_public_path__ + "img/discord.10ced1d0.svg";